var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddbank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.0526V6.63091L11.0515 0L22.103 6.63091V11.0526H20.9979V12C20.3108 12.0012 19.5 12.5632 19.5 13.25V15.5H17.6824V11.0526H15.4721V17.6824H16.1026C16.2448 18.1324 16.5375 18.5 17 18.5H19.5V20.75C19.5 20.835 19.5124 20.9181 19.5355 20.9985L17.6824 20.9979H0V17.6824H1.10515V11.0526H0ZM4.42061 11.0526V17.6824H6.63091V11.0526H4.42061ZM9.94637 11.0526V17.6824H12.1567V11.0526H9.94637ZM13.0933 7.47693C13.2045 7.20872 13.2617 6.92124 13.2618 6.63091C13.262 6.04455 13.0292 5.48216 12.6147 5.06744C12.2002 4.65272 11.6379 4.41965 11.0515 4.4195C10.4652 4.41935 9.90276 4.65214 9.48804 5.06666C9.07332 5.48117 8.84025 6.04345 8.84011 6.6298C8.84004 6.92014 8.89715 7.20764 9.00819 7.4759C9.11923 7.74417 9.28202 7.98793 9.48726 8.19328C9.69251 8.39863 9.93619 8.56154 10.2044 8.67271C10.4726 8.78388 10.7601 8.84114 11.0504 8.84121C11.3407 8.84129 11.6283 8.78417 11.8965 8.67313C12.1648 8.56209 12.4085 8.39931 12.6139 8.19406C12.8192 7.98881 12.9821 7.74513 13.0933 7.47693Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16H22V14C22 13.45 21.55 13 21 13C20.45 13 20 13.45 20 14V16H18C17.45 16 17 16.45 17 17C17 17.55 17.45 18 18 18H20V20C20 20.55 20.45 21 21 21C21.55 21 22 20.55 22 20V18H24C24.55 18 25 17.55 25 17C25 16.45 24.55 16 24 16Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddbank);
export default __webpack_public_path__ + "static/media/Addbank.bce6330a.svg";
export { ForwardRef as ReactComponent };